<template>
  <administrative>
    <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg w-1/2">
      <loading :showLoading="form.processing" />
      <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
        <form @submit.prevent="submitForm">
          <div class="grid grid-cols-8 gap-4 mb-4">
            <div class="col-span-4 sm:col-span-4">
              <breeze-label :required="true" :value="'Name'" />
              <breeze-input required v-model="form.name" class="w-full" />
              <breeze-input-error :message="form.errors?form.errors.name:''" />
            </div>
            <div class="col-span-4 sm:col-span-4">
              <breeze-label :required="true" :value="'Mobile'" />
              <breeze-input required type="number" v-model="form.mobile" class="w-full" />
              <breeze-input-error :message="form.errors?form.errors.mobile:''" />
            </div>
            <div class="col-span-8 sm:col-span-8">
              <breeze-label :required="true" :value="'Email'" />
              <breeze-input required v-model="form.email" class="w-full" />
              <breeze-input-error :message="form.errors?form.errors.email:''" />
            </div>
            <div class="col-span-4 sm:col-span-4">
              <breeze-label :value="'Date Of Birth'" />
              <breeze-input v-model="form.date_of_birth" type="date" class="w-full" />
              <breeze-input-error
                :message="form.errors.addFaculty?form.errors.addFaculty.date_of_birth:''"
              />
            </div>

            <div class="col-span-4 sm:col-span-4">
              <breeze-label :value="'Blood Group'" />
              <breeze-input v-model="form.blood_group" type="text" class="w-full" />
              <breeze-input-error
                :message="form.errors.addFaculty?form.errors.addFaculty.blood_group:''"
              />
            </div>
            <div class="col-span-8 sm:col-span-8">


              <FormMultiselect
                  label="Role"
                  :options="roles"
                  track-key="id"
                  label-key="name"
                  :object="true"
                  :required="true"
                  v-model="form.role"
                  :placeholder="'Select Role'"
                  :error="form.errors.role"
              />
            </div>
          </div>
          <button-link
            :href="route('administrative.user.list')"
            class="bg-red-500 mr-4 hover:bg-red-400"
          >Cancel</button-link>
          <breeze-button :disabled="form.processing">Save</breeze-button>
          <exception />
        </form>
      </div>
    </div>
  </administrative>
</template>

<script>
import Administrative from "@/Pages/Administrative/Administrative";
import BreezeTable from "@/Components/Table";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import ButtonLink from "@/Components/ButtonLink";
import Exception from "@/Components/Exception";
import { useForm } from "@inertiajs/inertia-vue3";
import Loading from "@/Components/Loading";
import SelectList from "@/Components/SelectList";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";


export default {
  components: {
    FormMultiselect,
    Administrative,
    BreezeTable,
    ButtonLink,
    BreezeInput,
    BreezeLabel,
    BreezeInputError,
    BreezeButton,
    Exception,
    Loading,
    SelectList
  },
  props: ["user", "roles"],
  data() {
    return {
      form: useForm({
        _method: "PUT",
        name: this.user.name,
        mobile: this.user.mobile,
        email: this.user.email,
        blood_group: this.user.blood_group,
        date_of_birth: this.user.date_of_birth,
        role: this.user.role
      })
    };
  },
  methods: {
    submitForm() {
      this.form.post(route("administrative.user.update", this.user.id), {
        preserveScroll: true,
        onSuccess: () => this.form.reset()
      });
    }
  }
};
</script>
